<template>
  <div class="home-notice">
    <div class="title"><span class="p1">商城公告</span></div>
    <div class="content">
      <van-swipe class="my-swipe" :autoplay="5000">
        <van-swipe-item v-for="(item,index) in noticeList" :key="index" class="ellipsis">{{item.title}}</van-swipe-item>
      </van-swipe>
    </div>
    <div class="more" @click="$router.push('/publicList')">更多</div>
  </div>
</template>

<script>
export default {
  name: "Notice",
  props: {
    noticeList: {
      type: Array
    }
  },
}
</script>

<style lang="less" scoped>
.home-notice {
  position: relative;
  display: flex;
  height: 24px;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  // background-color: pink;
  margin-top: 10px;
  .title {
    width: 80px;
    margin-left: 10px;
    .p1 {
      font-size: 16px;
      font-weight: 700;
      color: #f22d5d;
      margin-right: 10px;
    }
    .p2 {
      font-size: 14px;
    }
  }
  .content {
    flex: 1;
    text-align: left;
    line-height: 26px;
    .my-swipe {
      width: 14rem;
      display: flex;
      font-size: 14px;
      align-items: center;
      color: #7e7e7e;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    /deep/.van-swipe__indicators {
      display: none;
    }
  }
  .more {
    position: absolute;
    top: 1px;
    right: 0;
    width: 32px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    color: #c7c7c7;
    background-color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/modules/Notice.vue